<div class="col-md-12 pb-2 ziro-datatable-content">
  <ziro-breadcrumbs></ziro-breadcrumbs>
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <ziro-datatable
      [class]="'ziro-card'"
      [dataAutomation]="tableDataAutomation"
      [columns]="columns"
      [rowDataSource]="data"
      [uniqueRowIdentifier]="null"
      [truncateCell]="false"
      [wrapCellText]="true"
      [setColumnWidths]="false"
    ></ziro-datatable>
  }
</div>
